import { render, staticRenderFns } from "./PossiveisDuplicadas.vue?vue&type=template&id=3bb043af&scoped=true"
import script from "./PossiveisDuplicadas.vue?vue&type=script&lang=js"
export * from "./PossiveisDuplicadas.vue?vue&type=script&lang=js"
import style0 from "./PossiveisDuplicadas.vue?vue&type=style&index=0&id=3bb043af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb043af",
  null
  
)

export default component.exports